export default "__VITE_ASSET__DGHIZG8X__"